import { render, staticRenderFns } from "./GetEmailLink.vue?vue&type=template&id=45bdb70d&scoped=true&"
import script from "./GetEmailLink.vue?vue&type=script&lang=js&"
export * from "./GetEmailLink.vue?vue&type=script&lang=js&"
import style0 from "./GetEmailLink.vue?vue&type=style&index=0&id=45bdb70d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bdb70d",
  null
  
)

export default component.exports